// in src/users.js
import React from "react";
import {
    List,
    Edit,
    Create,
    Datagrid,
    SimpleForm,
    TextInput,
    SelectInput,
    DeleteButton,
    EditButton,
    TextField,
    ReferenceInput,
    SelectArrayInput,
    FunctionField,
    required,
} from "react-admin";

import LargePagination from "../core/LargePagination";
import { LVEditToolbar, LVCreateToolbar } from "../core/toolbars";

const SectionTitle = ({ children }) => <div>{children}</div>;

const MFA_TYPE_CHOICES = [
    { id: "totp", name: "Time-based One-time Password" },
    { id: "sms", name: "SMS" },
];

export const ClientMfaList = (props) => (
    <List title="All clients" perPage={500} pagination={<LargePagination />} {...props}>
        <Datagrid bulkActionButtons={false}>
            <TextField source="id" />
            <TextField source="clientName" />
            <FunctionField addLabel={false} render={(record) => record.allowedTypes.join(", ")} />
            <EditButton />
            <DeleteButton mutationMode="pessimistic"/>
        </Datagrid>
    </List>
);

const classes = {
    textInput: {
        display: "flex",
        width: "20rem",
    },
};

const ClientTitle = ({ record }) => {
    return <span>Client {record ? `"${record.clientName}"` : ""}</span>;
};

const validateClientMfaCreation = (values) => {
    const errors = {};

    if (!values.id) {
        errors.id = "You must choose a client";
    }

    if (!values.allowedTypes) {
        errors.allowedTypes = "You must choose at least one allowed MFA type";
    }

    return errors;
};

export const ClientMfaCreate = (props) => (
    <Create title="Create User" {...props}>
        <SimpleForm validate={validateClientMfaCreation} toolbar={<LVCreateToolbar />}>
            <SectionTitle>Select client MFA Options</SectionTitle>

            <ReferenceInput perPage={0} label="Client" source="id" reference="portal/clients">
                <SelectInput optionText="clientName" />
            </ReferenceInput>

            <SelectArrayInput label="MFA Types" source="allowedTypes" choices={MFA_TYPE_CHOICES} />
        </SimpleForm>
    </Create>
);

export const ClientMfaEdit = (props) => (
    <Edit title={<ClientTitle />} {...props}>
        <SimpleForm toolbar={<LVEditToolbar />}>
            <TextInput disabled source="id" />
            <TextInput disabled source="clientName" />

            <SelectArrayInput
                label="MFA Types"
                source="allowedTypes"
                validate={required()}
                choices={MFA_TYPE_CHOICES}
            />
        </SimpleForm>
    </Edit>
);
